<template>
  <div class="h-full relative flex flex-col" :class="{ 'justify-end': start }">
    <div
      v-if="showProgress"
      class="absolute inset-y-0 my-auto h-4.5 w-4.5 rounded-full overflow-hidden shadow-dropdown-light flex items-center justify-center z-20 transition-all duration-200"
      :class="{
        'bg-white': !progress,
        'bg-blue-sea-950': progress,
      }">
      <Check v-if="progress === 100" class="w-3.5 stroke-white stroke-4" />
    </div>
    <div
      class="z-10 w-[3px] absolute top-6 h-full transition-all duration-200 start-[7px]"
      :class="[
        { hidden: end },
        lineEmpty ? 'bg-secondary-400' : 'bg-blue-sea-950',
      ]"></div>
  </div>
</template>
<script setup lang="ts">
// import Checkmark from '@/assets/checkmark.svg?component';
import { Check } from 'lucide-vue-next';

defineProps({
  showProgress: {
    type: Boolean,
    default: true,
  },
  progress: {
    type: Number,
    default: 0,
  },
  start: {
    type: Boolean,
    default: false,
  },
  end: {
    type: Boolean,
    default: false,
  },
  lineEmpty: {
    type: Boolean,
    default: false,
  },
});
</script>
